module.exports = __webpack_public_path__ + "site/img/29.ab2493cd.jpg";